import React from 'react'
import { Route, Switch } from 'react-router-dom'
import routes from './routes'
import RequireAuthWrapper from '../pages/require_auth_wrapper/requireAuthWrapper'
import RouterTracker from '../routeTracker'

const Router = () => (
    <RouterTracker>
        <Switch>
            {Object.values(routes).map((route, index) => {
                if (route.component) {
                    return (
                        <Route
                            key={index}
                            exact={route.exact === true}
                            path={route.path}
                            render={(props) => (
                                <RequireAuthWrapper
                                    key={route.path}
                                    route={route}
                                >
                                    {React.createElement(route.component, {
                                        ...props,
                                    })}
                                </RequireAuthWrapper>
                            )}
                        />
                    )
                } else {
                    return null
                }
            })}
        </Switch>
    </RouterTracker>
)
export default Router
